module.exports = __webpack_public_path__ + "static/media/logo.176ee015.png";